import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { CartProvider } from "./context/CartContext";
import SiteHeader from "./components/SiteHeader";
import GlobalWhatsAppFab from "./components/GlobalWhatsAppFab";
import MarqueeBar from "./components/MarqueeBar";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicCatalog from "./pages/PublicCatalog";
import ProductDetail from "./pages/ProductDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import AdminConversations from "./pages/AdminConversations";
import AdminUsers from "./pages/AdminUsers";
import AdminOrders from "./pages/AdminOrders";
import AdminKnowledge from "./pages/AdminKnowledge";
import AdminPos from "./pages/AdminPos";
import AdminPosPurchase from "./pages/AdminPosPurchase";
import AdminPosRewards from "./pages/AdminPosRewards";
import AdminPosCommission from "./pages/AdminPosCommission";
import ProductForm from "./pages/ProductForm";
import CartPage from "./pages/CartPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SettingsProvider>
                    <AuthProvider>
                        <CartProvider>
                            <SiteHeader />
                            <Routes>
                                <Route path="/" element={<PublicCatalog />} />
                                <Route path="/p/:slug" element={<ProductDetail />} />
                                <Route path="/cart" element={<CartPage />} />
                                <Route path="/order-success/:orderNo" element={<CheckoutSuccess />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                {/* Obscure backend URL alias — dishare ke admin/user berwenang saja */}
                                <Route path="/rp-console" element={<AdminLogin />} />
                                <Route path="/rp-console/login" element={<AdminLogin />} />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute>
                                            <AdminDashboard />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/settings"
                                    element={
                                        <ProtectedRoute>
                                            <AdminSettings />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/conversations"
                                    element={
                                        <ProtectedRoute>
                                            <AdminConversations />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/users"
                                    element={
                                        <ProtectedRoute>
                                            <AdminUsers />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/orders"
                                    element={
                                        <ProtectedRoute>
                                            <AdminOrders />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/knowledge"
                                    element={
                                        <ProtectedRoute>
                                            <AdminKnowledge />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/pos"
                                    element={
                                        <ProtectedRoute>
                                            <AdminPos />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/pos/purchase"
                                    element={
                                        <ProtectedRoute>
                                            <AdminPosPurchase />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/pos/rewards"
                                    element={
                                        <ProtectedRoute>
                                            <AdminPosRewards />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/pos/commission"
                                    element={
                                        <ProtectedRoute>
                                            <AdminPosCommission />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/products/new"
                                    element={
                                        <ProtectedRoute>
                                            <ProductForm />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/admin/products/:id"
                                    element={
                                        <ProtectedRoute>
                                            <ProductForm />
                                        </ProtectedRoute>
                                    }
                                />
                            </Routes>
                            <GlobalWhatsAppFab />
                            <MarqueeBar />
                            <Toaster richColors position="top-center" />
                        </CartProvider>
                    </AuthProvider>
                </SettingsProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
